import { useLayoutEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { requestValid } from 'api/login';
import { getLoginInform, getHomeURL } from 'function/login';
import { useLoadingState } from 'global/loadingState';
import useLoginState from 'global/loginState';
import api from 'plugin/api';
import { RESPONSE_CODE, TOKEN, ROUTER_PATH } from 'types/const';

/**
 * 라우터 정보가 변경될 때마다 토큰 유효성 확인
 */
function useCheckLoginState() {
  /* router */
  const history = useHistory();
  const { pathname } = useLocation();

  /* recoil */
  const { setLoading } = useLoadingState();
  const {
    login: { [TOKEN]: token },
    setLogin
  } = useLoginState();

  /* watch */
  useLayoutEffect(() => {
    if (token) {
      valid();
    }
  }, [pathname, token]);

  /* method */
  // 토큰 유효성 확인
  const valid = async () => {
    setLoading(true);

    if (token && !api.defaults.headers.common[TOKEN]) {
      api.defaults.headers.common[TOKEN] = token;
    }

    const { data: { 'RE-TOKEN': reToken } = {}, code } = await requestValid();

    // 토큰 갱신
    if (reToken) {
      setLogin({ [TOKEN]: reToken });
    }

    setLoading(false);

    // 토큰이 유효한 경우 로그인 화면으로 이동 시
    if (code === RESPONSE_CODE.Success && pathname === ROUTER_PATH.login) {
      // 로그인 사용자가 해당되는 홈 화면 표시
      history.push(getHomeURL());
    }
  };
}

export default useCheckLoginState;
